import { useMemo } from 'react';
import { Card } from '../../../layout/Card.jsx';
import { formatIQD } from '../../../shared/format.js';
import { useDiscounts } from '../../pricing/hooks/useDiscounts.js';
import { useCheckout } from '../hooks/useCheckout.js';

// زر تفعيل/إلغاء خصم الأشقاء التلقائي لهذه الجلسة تحديداً. يظهر فقط للجلسات
// الساعية المؤهَّلة بخصم أشقاء فعّال (minQty بين 1 و siblingsIndex) — لأن الخصم
// الساعي يُحتسب بالكامل عند التسوية، واشتراط minQty ≥ 1 يضمن أن محاكاة الإلغاء
// (siblingsIndex 0) تُزيل الخصم فعلاً فتبقى المعاينة متسقة مع المبلغ المحصّل.
export function SiblingDiscountToggle({ session }) {
  const skipSibling = useCheckout((s) => s.skipSibling);
  const setSkipSibling = useCheckout((s) => s.setSkipSibling);
  const { data } = useDiscounts();

  const siblingIdx = Number(session?.siblingsIndex) || 0;
  const applicable = useMemo(() => {
    const list = Array.isArray(data) ? data : (data?.items || []);
    return list.filter((d) => {
      const minQty = Number(d.minQty) || 0;
      return d && d.isActive !== false && d.scope === 'sibling' && minQty >= 1 && minQty <= siblingIdx;
    });
  }, [data, siblingIdx]);

  if (session?.pricingType !== 'hourly' || applicable.length === 0) return null;

  const d = applicable[0];
  const label = d.type === 'percent' ? `${Number(d.value || 0)}%` : formatIQD(d.value || 0);
  const applied = !skipSibling;

  return (
    <Card>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span
            className="grid place-items-center w-7 h-7 rounded-full text-[14px]"
            style={{ background: '#DCFCE7' }}
          >
            👨‍👦
          </span>
          <div>
            <div className="font-bold text-[13px]">خصم الأشقاء ({label})</div>
            <div className="text-[11px]" style={{ color: applied ? '#15803D' : '#9A8F77' }}>
              {applied ? 'مُطبَّق على هذا الطفل' : 'مُلغى لهذا الطفل'}
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setSkipSibling(applied)}
          className="relative w-9 h-5 rounded-full transition-colors flex-none"
          style={{ background: applied ? '#15803D' : '#E5E0D5' }}
          aria-label="تبديل خصم الأشقاء"
        >
          <span
            className="absolute top-0.5 w-4 h-4 rounded-full bg-white shadow"
            style={{ insetInlineStart: applied ? 18 : 2, transition: 'inset-inline-start .15s' }}
          />
        </button>
      </div>
    </Card>
  );
}
